export class LookupDuplicatedCellsReport {
  constructor(
    public duplicatedFound: boolean = false,
    public duplicatedMnemonicId: number = null,
    public duplicatedKey: string = null
  ) {}
}
